import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/paycheck',
  component: () => import('../../routes/Paycheck.svelte'),
  card: {
    id: 'paycheck',
    title: 'Take-Home Pay',
    description: 'Calculate your net paycheck after federal, state, FICA taxes, and pre-tax deductions.',
    icon: 'payments',
    iconBgClass: 'bg-lime-50',
    iconTextClass: 'text-lime-600',
    href: '/paycheck',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Take-Home Pay Calculator – Free Paycheck Calculator',
    description: 'Free paycheck calculator to estimate your take-home pay. Calculate net pay after federal, state, and FICA taxes with pre-tax deduction support.',
  },
};

export default meta;
